import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TimelineListComponent } from './timeline/timeline-list/timeline-list.component';
import { BankListComponent } from './bank/bank-list/bank-list.component';
import { SalaryListComponent } from './salary/salary-list/salary-list.component';
import { TimelinesComponent } from './timelines/timelines.component';
import { PaymentListComponent } from './payment/payment-list/payment-list.component';
import { ParticularListComponent } from './particular/particular-list/particular-list.component';
import { ParticularCrudComponent } from './particular/particular-crud/particular-crud.component';
import { ProvidentFundsCrudComponent } from './Provident-funds/provident-funds-crud/provident-funds-crud.component';
import { ProvidentFundsListComponent } from './Provident-funds/provident-funds-list/provident-funds-list.component';
import { RenumarationComponent } from './payment/renumaration/renumaration.component';
import { EmployeeResolver } from 'src/app/shared/resolvers/employee.resolver';
import { ModuleGuard } from 'src/app/shared/guards/module.guard';
import { OrgChartComponent } from './org-chart/org-chart/org-chart.component';
import { SalaryPaymentComponent } from './salary-payment/salary-payment.component';

const routes: Routes = [
  {
    path: 'orgchart',
    component: OrgChartComponent,
  },
  {
    path: 'timeline-list',
    component: TimelineListComponent,
    resolve: { employeeId: EmployeeResolver},
    canActivate:[ModuleGuard],
    data: {
      title: 'timeline-list',
      modules:['DESIGNATION']
    }
  },
  {
    path: 'payment-list',
    component: PaymentListComponent,
    resolve: { employeeId: EmployeeResolver},
    data: {
      title: 'payment-list'
    }
  },
  {
    path: 'renumaration-list',
    component: RenumarationComponent,
    canActivate:[ModuleGuard],
    resolve: { employeeId: EmployeeResolver},
    data: {
      title: 'renumaration-list',
      modules:['REMUNERATION']
    }
  },
  {
    path: 'bank-list',
    component: BankListComponent,
    canActivate:[ModuleGuard],
    resolve: { employeeId: EmployeeResolver},
    data: {
      title: 'bank-list',
      modules:['BANK']
    }
  },
  {
    path: 'salary-list',
    component: SalaryListComponent,
    canActivate:[ModuleGuard],
    resolve: { employeeId: EmployeeResolver},
    data: {
      title: 'salary-list',
      modules:['SALARY']
    }
  },
  {
    path: 'timeline',
    component: TimelinesComponent,
    resolve: { employeeId: EmployeeResolver},
    data: {
      title: 'timeline'
    }
  },
  {
    path: 'particular-list',
    component: ParticularListComponent,
    canActivate:[ModuleGuard],
    data: {
      title: 'particular-list',
      modules:['PARTICULAR']
    }
  },
  {
    path: 'particular-crud',
    component: ParticularCrudComponent,
    data: {
      title: 'particular-crud'
    }
  },
  {
    path: 'providentFund-crud',
    component: ProvidentFundsCrudComponent,
    data: {
      title: 'providentFund-crud'
    }
  },
  {
    path: 'providentFund-list',
    component: ProvidentFundsListComponent,
    canActivate:[ModuleGuard],
    data: {
      title: 'providentFund-list',
      modules:['PROVIDENT FUND']
    }
  },
  {
    path: 'salary-payment',
    component: SalaryPaymentComponent,
    // canActivate:[ModuleGuard],
    // data: {
    //   title: 'salary-payment',
    //   modules:['PAYMENT']
    // }
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PayrollRoutingModule { }
